import React, { useState } from "react";

import {
  API_ENV_OPTIONS,
  ApiEnv,
  getApiEnv,
  isApiEnvSwitchEnabled,
  setApiEnv,
} from "../../api/apiEnv";

type ApiEnvSelectorProps = {
  /** compact: 로그인 화면용, panel: 설정 페이지용 */
  variant?: "compact" | "panel";
};

const ApiEnvSelector = ({ variant = "compact" }: ApiEnvSelectorProps) => {
  const [selected, setSelected] = useState<ApiEnv>(() => getApiEnv());

  if (!isApiEnvSwitchEnabled()) {
    return null;
  }

  const onApply = () => {
    if (selected === getApiEnv()) {
      return;
    }

    const nextLabel = selected === "development" ? "개발계" : "운영계";
    const confirmed = window.confirm(
      `API를 ${nextLabel}로 전환합니다.\n로그인 세션이 초기화되고 로그인 화면으로 이동합니다.`
    );
    if (!confirmed) {
      setSelected(getApiEnv());
      return;
    }

    setApiEnv(selected);
  };

  if (variant === "compact") {
    return (
      <div className="api-env-selector api-env-selector--compact">
        <label htmlFor="api-env-select">API 환경</label>
        <div className="api-env-selector__row">
          <select
            id="api-env-select"
            value={selected}
            onChange={(e) => setSelected(e.target.value as ApiEnv)}
          >
            {API_ENV_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label} ({option.url})
              </option>
            ))}
          </select>
          <button
            className="api-env-selector__apply"
            type="button"
            onClick={onApply}
            disabled={selected === getApiEnv()}
          >
            적용
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="api-env-selector api-env-selector--panel">
      <div className="api-env-option-list" role="radiogroup" aria-label="API 환경">
        {API_ENV_OPTIONS.map((option) => {
          const isActive = selected === option.value;
          return (
            <label
              key={option.value}
              className={`api-env-option ${isActive ? "is-selected" : ""}`}
            >
              <input
                type="radio"
                name="api-env"
                value={option.value}
                checked={isActive}
                onChange={() => setSelected(option.value)}
              />
              <span className="api-env-option__body">
                <span className="api-env-option__label">{option.label}</span>
                <span className="api-env-option__url">{option.url}</span>
              </span>
            </label>
          );
        })}
      </div>
      <button
        className="primary-btn api-env-selector__submit"
        type="button"
        onClick={onApply}
        disabled={selected === getApiEnv()}
      >
        선택한 환경 적용
      </button>
    </div>
  );
};

export default ApiEnvSelector;
